import clsx from "clsx";
import { icon } from "../../icons";
import { Spinner } from "../../spinner";

const SIZE = 15;

/** Props Interface */
interface StreamTaskListItemProps {
	text: string;
	isDone: boolean;
	isPending: boolean;
	render?: (text: string) => React.ReactNode | null;
}

export function StreamTaskListItem({ text, isDone, isPending, render }: StreamTaskListItemProps) {
	const state = isPending && !isDone ? "pending" : "done";
	const isError = text.startsWith("error//");

	const Icon = isError ? icon("X") : icon("BadgeCheck");

	/** Render */
	return (
		render?.(text) || (
			<div className="h-stack gap-3 items-center">
				<div
					className="flex-center"
					style={{
						width: SIZE,
						aspectRatio: 1,
					}}
				>
					{state === "pending" ? (
						<Spinner size={10} />
					) : (
						<Icon
							className={clsx(isError ? "text-red-500" : "stroke-emerald-500")}
							size={SIZE}
						/>
					)}
				</div>
				<p className={clsx("text-sm", !isError && "line-clamp-1")}>
					{text.replaceAll("error//", "")}
				</p>
			</div>
		)
	);
}
